<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'

const unmountWidget = ref()

type Props = {
  eventId: number
  configurationId: string
}

type Emits = { widgetLoaded: [boolean]; widgetError: [STATSCOREWidgetsError] }
const emit = defineEmits<Emits>()

const props = defineProps<Props>()

onMounted(() => {
  if (!window.STATSCOREWidgets) {
    throw new Error('STATSCOREWidgets is not defined')
  }

  /* tempfix: clear global 'lazyDestroy' timers, we handle cleanup anyway */
  const originalSetInterval = window.setInterval

  window.setInterval = ((...args: Parameters<typeof window.setInterval>) => {
    const id = originalSetInterval(...args)
    if (args[0].toString().includes('lazyDestroyInterval')) {
      clearInterval(id)
      window.setInterval = originalSetInterval
    }
    return id
  }) as typeof window.setInterval
  /* !tempfix */

  window.STATSCOREWidgets.onLoad((err: STATSCOREWidgetsError) => {
    if (err) {
      emit('widgetError', err)
      throw err
    }

    const element = document.getElementById(props.configurationId)

    const inputData = {
      eventId: props.eventId,
      language: 'en',
    }

    const options = {}

    if (!element) {
      return
    }

    const widget = new window.STATSCOREWidgets.WidgetGroup(
      element,
      props.configurationId,
      inputData,
      options,
    )

    widget.on('mount', () => {
      emit('widgetLoaded', true)
    })

    unmountWidget.value = () => widget.destroy()
  })
})

onBeforeUnmount(async () => {
  if (unmountWidget.value) {
    await unmountWidget.value()
  }
})
</script>

<template>
  <div :id="configurationId" />
</template>
